/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListEvalSuiteVersionsRequest = {
  suiteId: string;
  after?: string | undefined;
  limit?: number | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

export type ListEvalSuiteVersionsManifest = {
  schemaVersion?: string | undefined;
  tasks: Array<any | null>;
  metadata?: { [k: string]: any } | undefined;
};

export type ListEvalSuiteVersionsData = {
  id: string;
  object: "eval.suite.version";
  suiteId: string;
  version: number;
  manifest: ListEvalSuiteVersionsManifest;
  datasetFileIds: Array<string>;
  metadata: { [k: string]: string };
  createdAt: number;
};

/**
 * OK
 */
export type ListEvalSuiteVersionsResponseBody = {
  object: "list";
  data: Array<ListEvalSuiteVersionsData>;
  firstId?: string | undefined;
  lastId?: string | undefined;
  hasMore: boolean;
};

/** @internal */
export const ListEvalSuiteVersionsRequest$inboundSchema: z.ZodType<
  ListEvalSuiteVersionsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  suite_id: z.string(),
  after: z.string().optional(),
  limit: z.number().int().default(20),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "suite_id": "suiteId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListEvalSuiteVersionsRequest$Outbound = {
  suite_id: string;
  after?: string | undefined;
  limit: number;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListEvalSuiteVersionsRequest$outboundSchema: z.ZodType<
  ListEvalSuiteVersionsRequest$Outbound,
  z.ZodTypeDef,
  ListEvalSuiteVersionsRequest
> = z.object({
  suiteId: z.string(),
  after: z.string().optional(),
  limit: z.number().int().default(20),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    suiteId: "suite_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listEvalSuiteVersionsRequestToJSON(
  listEvalSuiteVersionsRequest: ListEvalSuiteVersionsRequest,
): string {
  return JSON.stringify(
    ListEvalSuiteVersionsRequest$outboundSchema.parse(
      listEvalSuiteVersionsRequest,
    ),
  );
}
export function listEvalSuiteVersionsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListEvalSuiteVersionsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEvalSuiteVersionsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEvalSuiteVersionsRequest' from JSON`,
  );
}

/** @internal */
export const ListEvalSuiteVersionsManifest$inboundSchema: z.ZodType<
  ListEvalSuiteVersionsManifest,
  z.ZodTypeDef,
  unknown
> = z.object({
  schema_version: z.string().default("2026-05-27"),
  tasks: z.array(z.nullable(z.any())),
  metadata: z.record(z.any()).optional(),
}).transform((v) => {
  return remap$(v, {
    "schema_version": "schemaVersion",
  });
});
/** @internal */
export type ListEvalSuiteVersionsManifest$Outbound = {
  schema_version: string;
  tasks: Array<any | null>;
  metadata?: { [k: string]: any } | undefined;
};

/** @internal */
export const ListEvalSuiteVersionsManifest$outboundSchema: z.ZodType<
  ListEvalSuiteVersionsManifest$Outbound,
  z.ZodTypeDef,
  ListEvalSuiteVersionsManifest
> = z.object({
  schemaVersion: z.string().default("2026-05-27"),
  tasks: z.array(z.nullable(z.any())),
  metadata: z.record(z.any()).optional(),
}).transform((v) => {
  return remap$(v, {
    schemaVersion: "schema_version",
  });
});

export function listEvalSuiteVersionsManifestToJSON(
  listEvalSuiteVersionsManifest: ListEvalSuiteVersionsManifest,
): string {
  return JSON.stringify(
    ListEvalSuiteVersionsManifest$outboundSchema.parse(
      listEvalSuiteVersionsManifest,
    ),
  );
}
export function listEvalSuiteVersionsManifestFromJSON(
  jsonString: string,
): SafeParseResult<ListEvalSuiteVersionsManifest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEvalSuiteVersionsManifest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEvalSuiteVersionsManifest' from JSON`,
  );
}

/** @internal */
export const ListEvalSuiteVersionsData$inboundSchema: z.ZodType<
  ListEvalSuiteVersionsData,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  object: z.literal("eval.suite.version"),
  suite_id: z.string(),
  version: z.number().int(),
  manifest: z.lazy(() => ListEvalSuiteVersionsManifest$inboundSchema),
  dataset_file_ids: z.array(z.string()),
  metadata: z.record(z.string()),
  created_at: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "suite_id": "suiteId",
    "dataset_file_ids": "datasetFileIds",
    "created_at": "createdAt",
  });
});
/** @internal */
export type ListEvalSuiteVersionsData$Outbound = {
  id: string;
  object: "eval.suite.version";
  suite_id: string;
  version: number;
  manifest: ListEvalSuiteVersionsManifest$Outbound;
  dataset_file_ids: Array<string>;
  metadata: { [k: string]: string };
  created_at: number;
};

/** @internal */
export const ListEvalSuiteVersionsData$outboundSchema: z.ZodType<
  ListEvalSuiteVersionsData$Outbound,
  z.ZodTypeDef,
  ListEvalSuiteVersionsData
> = z.object({
  id: z.string(),
  object: z.literal("eval.suite.version"),
  suiteId: z.string(),
  version: z.number().int(),
  manifest: z.lazy(() => ListEvalSuiteVersionsManifest$outboundSchema),
  datasetFileIds: z.array(z.string()),
  metadata: z.record(z.string()),
  createdAt: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    suiteId: "suite_id",
    datasetFileIds: "dataset_file_ids",
    createdAt: "created_at",
  });
});

export function listEvalSuiteVersionsDataToJSON(
  listEvalSuiteVersionsData: ListEvalSuiteVersionsData,
): string {
  return JSON.stringify(
    ListEvalSuiteVersionsData$outboundSchema.parse(listEvalSuiteVersionsData),
  );
}
export function listEvalSuiteVersionsDataFromJSON(
  jsonString: string,
): SafeParseResult<ListEvalSuiteVersionsData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEvalSuiteVersionsData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEvalSuiteVersionsData' from JSON`,
  );
}

/** @internal */
export const ListEvalSuiteVersionsResponseBody$inboundSchema: z.ZodType<
  ListEvalSuiteVersionsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("list"),
  data: z.array(z.lazy(() => ListEvalSuiteVersionsData$inboundSchema)),
  first_id: z.string().optional(),
  last_id: z.string().optional(),
  has_more: z.boolean(),
}).transform((v) => {
  return remap$(v, {
    "first_id": "firstId",
    "last_id": "lastId",
    "has_more": "hasMore",
  });
});
/** @internal */
export type ListEvalSuiteVersionsResponseBody$Outbound = {
  object: "list";
  data: Array<ListEvalSuiteVersionsData$Outbound>;
  first_id?: string | undefined;
  last_id?: string | undefined;
  has_more: boolean;
};

/** @internal */
export const ListEvalSuiteVersionsResponseBody$outboundSchema: z.ZodType<
  ListEvalSuiteVersionsResponseBody$Outbound,
  z.ZodTypeDef,
  ListEvalSuiteVersionsResponseBody
> = z.object({
  object: z.literal("list"),
  data: z.array(z.lazy(() => ListEvalSuiteVersionsData$outboundSchema)),
  firstId: z.string().optional(),
  lastId: z.string().optional(),
  hasMore: z.boolean(),
}).transform((v) => {
  return remap$(v, {
    firstId: "first_id",
    lastId: "last_id",
    hasMore: "has_more",
  });
});

export function listEvalSuiteVersionsResponseBodyToJSON(
  listEvalSuiteVersionsResponseBody: ListEvalSuiteVersionsResponseBody,
): string {
  return JSON.stringify(
    ListEvalSuiteVersionsResponseBody$outboundSchema.parse(
      listEvalSuiteVersionsResponseBody,
    ),
  );
}
export function listEvalSuiteVersionsResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<ListEvalSuiteVersionsResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEvalSuiteVersionsResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEvalSuiteVersionsResponseBody' from JSON`,
  );
}
